// Types
// import { Feature } from './constants';

import { Locale } from '@shopee-user/global';

type NonLiveStaticToggleOverrideOptions = {
  nonLiveValue?: Partial<Record<Locale, boolean>>;
};
type NonLiveStaticToggleOverrideConfig =
  | boolean
  | undefined
  | NonLiveStaticToggleOverrideOptions;

export type NonLiveStaticToggleOverrideFeatureToggleConfig = Record<
  string,
  NonLiveStaticToggleOverrideConfig
>;

// 1. Add the hardcoded value here.
// 2. Dev will need to manually set value to false before merging to master if the feature is not ready to be released yet.
export const NON_LIVE_STATIC_TOGGLE_OVERRIDE_CONFIG: NonLiveStaticToggleOverrideFeatureToggleConfig = {
  // e.g [Feature.XXX]: { nonLiveValue: true }
};
